import { Box } from "@mantine/core";
import { Link } from "react-router-dom";
import logo from "shared/assets/images/headerLogo.svg";
import { useUser } from "shared/hooks/_user/useUser";

type Props = {
  alt?: string;
  width?: number;
  height?: number;
};

export const MainLogo = (props: Props) => {
  const user = useUser();

  return (
    <Box pl={10} pr={10}>
      <Link to={user ? "/main" : "/"} style={{ display: "flex", height: "min-content" }}>
        <img src={logo} {...props} />
      </Link>
    </Box>
  );
};
